<template>
  <div class="loading-container" :class="{ active: isLoading }">
    <transition>
      <div v-if="isLoading" class="loading-indicator"></div>
    </transition>
  </div>
</template>

<script>
export default {
  props: {
    isLoading: Boolean
  }
};
</script>

<style lang="scss">
.loading-container {
  background-color: darken($color-purple, 10%);
  box-shadow: 0 1px 0 rgba($color-purple-highlight, 0.4);
  height: 2px;
  margin-left: -1.25rem;
  margin-right: -1.25rem;
  opacity: 0;
  position: relative;
  transition: opacity 0.2s ease;
  width: 100vw;

  &.active {
    opacity: 1;
    transition-duration: 0.2s;
  }

  // Override global vertical spacing for empty divs
  &:empty {
    margin-top: $gutter;
  }
}

.loading-indicator {
  animation: 2.2s ease vacilate infinite both, 1.1s linear unfadeable infinite;
  background-color: $color-accent;
  border-radius: 1px;
  box-shadow: 0 0 10px 2px $color-accent;
  display: block;
  position: absolute;
  bottom: 0;
  left: -5px;
  width: 10px;
  height: 100%;
  z-index: 1;

  &::after {
    background: linear-gradient(
      to right,
      transparent,
      rgba(cyan, 0.4) 50%,
      transparent
    );
    content: "";
    display: block;
    position: absolute;
    top: 0;
    left: -200%;
    width: 500%;
    height: 2px;
    z-index: -1;
  }
}
</style>
